import web3 from "../web3";
import ABI from "../abi/deployer.json";

export const deployerAddress = "0xa5273895CF4564EBe3aeA84C50b5F315A9B0c11a";

const instance = async () => {
  try {
    return new web3.eth.Contract(ABI.abi, deployerAddress);
  } catch (error) {
    console.log(error);
  }
};

export default instance;
